import { Injectable } from '@angular/core';
import { InputType } from '@capturum/builders/core';
import { InputTypeBuilder } from '../input/input-type.builder';

@Injectable({ providedIn: 'root' })
export class ToggleInputTypeBuilder extends InputTypeBuilder {
  protected inputType: string = InputType.toggle;
}
